module.exports = __webpack_public_path__ + "assets/images/f7133ea7d8b9d026ebe0296c6bdab6bf.png";